if (!customElements.get('banner-with-tabs')) {
  class BannerWithTabs extends TabsComponent {
    constructor() {
      super();
      this.totalItems = this.buttons.length;
      this.addEventListener('tabChange', this.handleTabChange.bind(this));
      this.sectionId = this.dataset.sectionId;
      this.section = document.querySelector(`.section-${this.sectionId}`);
      this.initAutoplay();
      this.initMobileScrollArrow();

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          const index = Number(e.target.dataset.index);
          this.setActiveTab(index);
        });
      }
    }

    get cardPanels() {
      return Array.from(this.querySelectorAll('.banner-with-tabs__cards .tabs__content'));
    }

    get banners() {
      return Array.from(this.section.querySelectorAll('.banner-with-tabs__banner'));
    }

    get tabContentPanels() {
      return Array.from(this.querySelectorAll('.banner-with-tabs__tab-panel'));
    }

    get dots() {
      return Array.from(this.querySelectorAll('.banner-with-tabs__dot'));
    }

    handleTabChange(e) {
      const { selectedIndex } = e.detail;

      this.banners.forEach(b => b.classList.remove('active'));
      if (this.banners[selectedIndex]) {
        this.banners[selectedIndex].classList.add('active');
      }

      this.tabContentPanels.forEach(p => p.classList.remove('active'));
      if (this.tabContentPanels[selectedIndex]) {
        this.tabContentPanels[selectedIndex].classList.add('active');
      }

      const cards = this.cardPanels;
      cards.forEach(p => p.classList.remove('active'));
      if (cards[selectedIndex]) {
        cards[selectedIndex].classList.add('active');
      }

      this.dots.forEach(dot => {
        dot.classList.toggle('active', parseInt(dot.dataset.index) === selectedIndex);
      });

      if (cards.length) {
        this.updateCardStack(selectedIndex, cards);
      }
    }

    updateCardStack(selectedIndex, cards) {
      const priorityItems = {};
      cards.forEach(p => p.classList.remove('prev-item', 'next-item'));

      const nextCount = this.totalItems - selectedIndex - 1;

      for (let i = 0; i < selectedIndex; i++) {
        cards[i].classList.add('prev-item');
      }
      for (let i = 0; i < nextCount; i++) {
        cards[this.totalItems - i - 1].classList.add('next-item');
      }

      const prevItems = Array.from(this.querySelectorAll('.banner-with-tabs__cards .prev-item'));
      const nextItems = Array.from(this.querySelectorAll('.banner-with-tabs__cards .next-item'));

      nextItems.forEach((item, i) => {
        priorityItems[i + 1] = { item };
      });
      prevItems.forEach((item, i) => {
        priorityItems[nextCount + i + 1] = { item };
      });
      if (cards[selectedIndex]) {
        priorityItems[0] = { item: cards[selectedIndex] };
      }

      const total = Object.keys(priorityItems).length;
      for (const [i, obj] of Object.entries(priorityItems)) {
        const index = parseInt(i);
        const transform = `translate3d(0, ${index * 22}px, 0) scale(${1 - index * 0.07})`;
        obj.item.style.setProperty('--card-transform', transform);
        obj.item.style.setProperty('--card-z-index', total - index + 1);
      }
    }

    initMobileScrollArrow() {
      const navWrap = this.querySelector('.tabs__nav-wrap');
      if (!navWrap || !navWrap.classList.contains('swipe-mobile')) return;
      const updateArrow = () => {
        const scrollLeft = navWrap.scrollLeft;
        const clientWidth = navWrap.clientWidth;
        const scrollWidth = navWrap.scrollWidth;
        const atEnd = Math.ceil(scrollLeft + clientWidth) >= scrollWidth;
        navWrap.classList.toggle('swipe--end', atEnd);
      };
      navWrap.addEventListener('scroll', updateArrow, { passive: true });
      updateArrow();
    }

    initAutoplay() {
      this._autoplay = this.dataset.autoplay === 'true';
      this._speed = (parseInt(this.dataset.autoplaySpeed) || 5) * 1000;

      if (this._autoplay) {
        this.startAutoplay();
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }

      this.dots.forEach(dot => {
        dot.addEventListener('click', () => {
          this.setActiveTab(parseInt(dot.dataset.index));
          if (this._autoplay) {
            this.stopAutoplay();
            this.startAutoplay();
          }
        });
      });
    }

    startAutoplay() {
      this.stopAutoplay();
      this._timer = setInterval(() => {
        const next = (this.selectedIndex + 1) % this.totalItems;
        this.setActiveTab(next);
      }, this._speed);
    }

    stopAutoplay() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-selected' && oldValue !== null && oldValue !== newValue) {
        const toElement = this.section.querySelector(`.banner-with-tabs__banner[data-index="${newValue}"]`);
        if (toElement) {
          setTimeout(() => {
            if (toElement.classList.contains('active')) {
              toElement.querySelectorAll('motion-element').forEach(el => {
                setTimeout(() => el && el.refreshAnimation());
              });
            }
          });
        }
      }
    }
  }
  customElements.define('banner-with-tabs', BannerWithTabs);
}
